// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__3OJ2A","title":"Block_title__26a8w","handler":"Block_handler__fO6wt","body":"Block_body__1bQwe"};